import React from "react"
import { ToastContainer, toast } from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css';

export default () => {
  return (
    <ToastContainer dir="rtl" enableMultiContainer position={toast.POSITION.BOTTOM_RIGHT} />
  )
}
